import React, { forwardRef, HTMLAttributes } from 'react';
import { PatternFormat, PatternFormatProps } from 'react-number-format';
import { Box, TextField, TextFieldProps, Typography } from '@mui/material';

export type InnFieldProps = Omit<TextFieldProps, 'defaultValue' | 'type'> & {
  value?: string;
  defaultValue?: PatternFormatProps['defaultValue'];
  type?: PatternFormatProps['type'];
};

export const InnField = forwardRef<
  HTMLAttributes<HTMLInputElement>,
  InnFieldProps
>((props, ref) => {
  const {
    onChange,
    value,
    fullWidth = true,
    defaultValue,
    label,
    size = 'small',
    ...otherProps
  } = props;

  return (
    <Box width="100%">
      {label && (
        <Typography variant="body2" color="text.secondary" mb={1}>
          {label}
        </Typography>
      )}
      <PatternFormat
        customInput={TextField}
        format="############"
        defaultValue={defaultValue}
        value={value}
        valueIsNumericString
        onValueChange={(values) => {
          if (onChange) {
            onChange({
              target: { value: values.value },
            } as React.ChangeEvent<HTMLInputElement>);
          }
        }}
        fullWidth={fullWidth}
        size={size}
        {...otherProps}
        inputRef={ref}
      />
    </Box>
  );
});

InnField.displayName = 'InnField';
